import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value"]

import { computed } from 'vue';

import store from '@/store';
import router from '@/router';
import { useUiStore } from '@/stores';

import { HomeIcon, LogoutIcon } from '@heroicons/vue/outline';
import BaseTemplate from '@/views/templates/BaseTemplate.vue';
import { NavigationGetters } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsTemplate',
  setup(__props) {

const uiStore = useUiStore();

const sideNavigationItems = computed(
    () => store.getters[NavigationGetters.SETTINGS_SIDE_NAVIGATION_ITEMS],
);

const showLogout = computed(() => location.host !== 'embed.mobcall.com');

const handleLocaleChange = (event: Event) => {
    const selectedLocale = (event.target as HTMLInputElement).value;
    uiStore.setLocale(selectedLocale);
};

const handleHomeClick = () => {
    router.push('/');
};

const handleLogoutClick = () => {
    router.push('/logout');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseTemplate, {
    "navigation-items": sideNavigationItems.value,
    "router-key": _ctx.$route.fullPath
  }, {
    headerActions: _withCtx(() => [
      false
        ? _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 0,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
            class: "border-none bg-inherit ring-0 focus:border-none focus:outline-none focus:ring-0",
            onChange: handleLocaleChange
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (locale) => {
              return (_openBlock(), _createElementBlock("option", {
                key: `locale-${locale}`,
                value: locale
              }, _toDisplayString(locale), 9, _hoisted_1))
            }), 128))
          ], 544)), [
            [_vModelSelect, _ctx.$i18n.locale]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "text-primary hover:text-primary-400 mr-2",
        onClick: handleHomeClick
      }, [
        _createVNode(_unref(HomeIcon), {
          class: "h-6 w-6",
          "aria-hidden": "true"
        })
      ]),
      (showLogout.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "text-primary hover:text-primary-400",
            onClick: handleLogoutClick
          }, [
            _createVNode(_unref(LogoutIcon), {
              class: "h-6 w-6",
              "aria-hidden": "true"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["navigation-items", "router-key"]))
}
}

})